import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import form_data from "./formData";
const isProduction = process.env.NODE_ENV === 'production';
const API_BASE_URL = isProduction
  ? (process.env.REACT_APP_BNSKEJI_API_BASE_URL || 'https://fxapi.zzddww.com/index.php/BnsKeJi')
  : '/x/bkj';  // 开发环境用代理 → BnsKeJi


const BnsKeJiApi = createApi({
    reducerPath: 'BnsKeJiApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL        
    }),
    tagTypes:['taskManage','houduankaifa','bnsGoods',],
    endpoints(build) {
        return {            
            //短信验证码登录
            userLogin: build.mutation({
                query(user) {
                    return {
                        url: '/userLogin',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),
            //密码登录
            userMmLogin: build.mutation({
                query(user) {
                    return {
                        url: '/userMmLogin',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),
            //登录短信验证码
            loginCode: build.mutation({
                query(user) {
                    return {
                        url: '/loginCode',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),
             //开发/产品/新增
             bnsGoodsAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGoodsAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGoods']
            }),           
            //开发/产品/修改保存
            bnsGoodsUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGoodsUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGoods']
            }),
            //开发/产品/删除
            bnsGoodsDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGoodsDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGoods']
            }),
            //开发/产品/修改
            bnsGoodsUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsGoodsUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGoods']
            }),
            //开发/产品/列表
            bnsGoodsList: build.query({
                query(user) {
                    return {
                        url: '/bnsGoodsList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGoods']
            }),
             //开发/产品/功能/新增
             bnsGongNengAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGongNengAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGongNeng','bnsGoods']
            }),           
             //开发/产品/功能/删除
             bnsGongNengDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGongNengDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGongNeng']
            }),           
             //开发/产品/功能/修改保存
             bnsGongNengUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGongNengUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGongNeng','bnsGoods']
            }),           
           
            //开发/产品/功能/修改
            bnsGongNengUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsGongNengUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGongNeng']
            }),
            //开发/产品/功能/列表
            bnsGongNengList: build.query({
                query(user) {
                    return {
                        url: '/bnsGongNengList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGongNeng',]
            }),     
             //开发/需求/新增
             bnsXuQiuAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXuQiuAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXuQiu']
            }),           
            //开发/需求/修改保存
            bnsXuQiuUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXuQiuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXuQiu']
            }),
            //开发/需求/删除
            bnsXuQiuDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXuQiuDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXuQiu']
            }),
            //开发/需求/状态
            bnsXuQiuState: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXuQiuState',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXuQiu']
            }),
            //开发/需求/修改
            bnsXuQiuUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsXuQiuUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXuQiu']
            }),
            //开发/需求/列表
            bnsXuQiuList: build.query({
                query(user) {
                    return {
                        url: '/bnsXuQiuList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXuQiu']
            }),
            //新增任务
            taskManageAdd: build.mutation({
                query(user) {
                    return {
                        url: '/taskManageAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                // 同步失效项目树，便于 ProjectTabs 的 useGetXMTree2Query 自动刷新
                invalidatesTags:['taskManage','bnsXiangMu']
            }),
            //任务列表
            taskManageList: build.query({
                query(user) {
                    
                    return {
                        url: '/taskManageList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['taskManage']
            }),
            //任务修改
            taskManageUpdate: build.query({
                query(user) {
                    return {
                        url: '/taskManageUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['taskManage']
            }),
            //修改保存任务
            taskManageUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/taskManageUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['taskManage','bnsGoods']
            }),           
            //删除任务
            taskManageDel: build.mutation({
                query(user) {
                    return {
                        url: '/taskManageDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['taskManage']
            }), 
            //获取树
            getXMTree: build.query({
                query(user) {
                    return {
                        url: '/getXMTree',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['taskManage','bnsGoods']
            }), 
            //审核任务
            taskManageAudit: build.mutation({
                query(user) {
                    return {
                        url: '/taskManageAudit',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['taskManage']
            }), 
            
            //新增后端开发任务
            houduankaifaAdd: build.mutation({
                query(user) {
                    return {
                        url: '/houduankaifaAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['houduankaifa','bnsGoods']
            }),
            //后端开发任务列表
            houduankaifaList: build.query({
                query(user) {                    
                    return {
                        url: '/houduankaifaList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['houduankaifa']
            }),
            //后端开发任务修改
            houduankaifaUpdate: build.query({
                query(user) {
                    return {
                        url: '/houduankaifaUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['houduankaifa']
            }),
            //修改保存后端开发任务
            houduankaifaUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/houduankaifaUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['houduankaifa','bnsGoods','taskManage']
            }),           
            //删除后端开发任务
            houduankaifaDel: build.mutation({
                query(user) {
                    return {
                        url: '/houduankaifaDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['houduankaifa','bnsGoods']
            }), 
            
             //后端任务/子模块/新增
             bnsBanBenAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsBanBenAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsBanBen','bnsGoods']
            }),           
            //后端任务/子模块/修改保存
            bnsBanBenUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsBanBenUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsBanBen','taskManage','bnsGoods']
            }),
            //后端任务/子模块/删除
            bnsBanBenDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsBanBenDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsBanBen','bnsGoods']
            }),
            //后端任务/子模块/修改
            bnsBanBenUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsBanBenUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsBanBen']
            }),
            //后端任务/子模块/列表
            bnsBanBenList: build.query({
                query(user) {
                    return {
                        url: '/bnsBanBenList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsBanBen']
            }),
            
            //业务账/新增产品类型
            goodsTypeAdd: build.mutation({
                query(user) {
                    return {
                        url: '/goodsTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goodsType']
            }),
            //业务账/产品类型列表
            goodsTypeList: build.query({
                query(user) {
                    
                    return {
                        url: '/goodsTypeList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['goodsType']
            }),
            //业务账/产品类型修改
            goodsTypeUpdate: build.query({
                query(user) {
                    return {
                        url: '/goodsTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['goodsType']
            }),
            //业务账/修改保存产品类型
            goodsTypeUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/goodsTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goodsType']
            }),
            //业务账/删除产品类型
            goodsTypeDel: build.mutation({
                query(user) {
                    return {
                        url: '/goodsTypeDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goodsType']
            }),
            //业务账/新增产品
            goodsAdd: build.mutation({
                query(user) {
                    return {
                        url: '/goodsAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goods']
            }),
            //业务账/产品列表
            goodsList: build.query({
                query(user) {
                    return {
                        url: '/goodsList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['goods']
            }),
            //业务账/产品修改
            goodsUpdate: build.query({
                query(user) {
                    return {
                        url: '/goodsUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['goods']
            }),
            //业务账/修改保存产品
            goodsUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/goodsUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goods']
            }),
            //业务账/删除产品
            goodsDel: build.mutation({
                query(user) {
                    return {
                        url: '/goodsDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['goods']
            }),
            //业务账/新增客户
            addClient: build.mutation({
                query(user) {
                    return {
                        url: '/clientAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['client']
            }),
            //业务账/客户列表
            clientList: build.query({
                query(user) {
                    
                    return {
                        url: '/clientList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['client']
            }),
            //业务账/客户修改
            clientUpdate: build.query({
                query(user) {
                    return {
                        url: '/clientUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['client']
            }),
            
            //业务账/修改保存客户
            updateSaveClient: build.mutation({
                query(user) {
                    return {
                        url: '/clientUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['client']
            }),
            //业务账/删除客户
            delClient: build.mutation({
                query(user) {
                    return {
                        url: '/clientDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['client']
            }),
            //业务账/客户全部操作员
            getClientUid: build.query({
                query(user) {
                    return {
                        url: '/getClientUid',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['client']
            }),
            //业务账/新增客户类型
            clientTypeAdd: build.mutation({
                query(user) {
                    return {
                        url: '/clientTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['clientType']
            }),
            //业务账/客户类型列表
            clientTypeList: build.query({
                query(user) {
                    
                    return {
                        url: '/clientTypeList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['clientType']
            }),
            //业务账/客户类型修改
            clientTypeUpdate: build.query({
                query(user) {
                    return {
                        url: '/clientTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['clientType']
            }),
            //业务账/修改保存客户类型
            clientTypeUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/clientTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['clientType']
            }),
            //业务账/删除客户类型
            clientTypeDel: build.mutation({
                query(user) {
                    return {
                        url: '/clientTypeDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['clientType']
            }),
            //新增收支
            incomeExpenditureAdd: build.mutation({
                query(user) {
                    return {
                        url: '/incomeExpenditureAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['incomeExpenditure','businessNum']
            }),
            //收支列表
            incomeExpenditureList: build.query({
                query(user) {
                    return {
                        url: '/incomeExpenditureList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['incomeExpenditure']
            }),
            //收支修改
            incomeExpenditureUpdate: build.query({
                query(user) {
                    return {
                        url: '/incomeExpenditureUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['incomeExpenditure','businessNum']
            }),
            //修改保存收支
            incomeExpenditureUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/incomeExpenditureUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['incomeExpenditure','businessNum']
            }),
            //删除收支
            incomeExpenditureDel: build.mutation({
                query(user) {
                    return {
                        url: '/incomeExpenditureDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['incomeExpenditure']
            }),
            //审核收支
            incomeExpenditureAudit: build.mutation({
                query(user) {
                    return {
                        url: '/incomeExpenditureAudit',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['incomeExpenditure','incomeExpenditureHx']
            }),
            //取消审核收支
            incomeExpenditureCancelAudit: build.mutation({
                query(user) {
                    return {
                        url: '/incomeExpenditureCancelAudit',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['incomeExpenditure','incomeExpenditureHx']
            }),
            //旅行社业务账团号列表
            tuanHaoList: build.query({
                query(user) {
                    return {
                        url: '/tuanHaoList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),
            //旅行社业务账收支列表
            shouZhiList: build.query({
                query(user) {
                    return {
                        url: '/shouZhiList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
            }),
            //产品规格新增
            bnsGuiGeAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGuiGeAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGuiGe']
            }),
            //产品规格修改保存
            bnsGuiGeUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGuiGeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGuiGe']
            }),
            //产品规格删除
            bnsGuiGeDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsGuiGeDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsGuiGe']
            }),
            //产品规格修改
            bnsGuiGeUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsGuiGeUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGuiGe']
            }),
            //产品规格列表
            bnsGuiGeList: build.query({
                query(user) {
                    return {
                        url: '/bnsGuiGeList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsGuiGe']
            }),
            //新增收支子类型
            financeSubTypeAdd: build.mutation({
                query(user) {
                    return {
                        url: '/financeSubTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['financeSubType']
            }),
            //收支子类型列表
            financeSubTypeList: build.query({
                query(user) {
                    
                    return {
                        url: '/financeSubTypeList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['financeSubType']
            }),
            //收支子类型修改
            financeSubTypeUpdate: build.query({
                query(user) {
                    return {
                        url: '/financeSubTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['financeSubType']
            }),
            //修改保存收支子类型
            financeSubTypeUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/financeSubTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['financeSubType']
            }),
            //删除收支子类型
            financeSubTypeDel: build.mutation({
                query(user) {
                    return {
                        url: '/financeSubTypeDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['financeSubType']
            }),
            //新增团队任务
            renwuAdd: build.mutation({
                query(user) {
                    return {
                        url: '/renwuAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['renwu']
            }),
            //删除团队任务
            renwuDel: build.mutation({
                query(user) {
                    return {
                        url: '/renwuDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['renwu']
            }),
            //修改保存团队任务
            renwuUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/renwuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['renwu']
            }),
            //团队任务列表
            renwuList: build.query({
                query(user) {
                    return {
                        url: '/renwuList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['renwu']
            }),
            //团队任务修改
            renwuUpdate: build.query({
                query(user) {
                    return {
                        url: '/renwuUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['renwu']
            }),
             //项目设计/项目/新增
             bnsXiangMuAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMu']
            }),           
            //项目设计/项目/修改保存
            bnsXiangMuUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMu']
            }),
            //项目设计/项目/删除
            bnsXiangMuDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMu']
            }),
            //项目设计/项目/修改
            bnsXiangMuUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMu']
            }),
           
            //项目设计/项目/修改
            getXMTree2: build.query({
                query(user) {
                    return {
                        url: '/getXMTree2',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMu','bnsGoods']
            }),
            //项目设计/项目/列表
            bnsXiangMuList: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMu']
            }),
            //项目设计/项目/获取树
            getXMXQTree: build.query({
                query(user) {
                    return {
                        url: '/getXMXQTree',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMu']
            }),
            //项目设计/需求/新增
                bnsXiangMuXuQiuAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuXuQiuAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuXuQiu']
            }),           
            //项目设计/需求/删除
            bnsXiangMuXuQiuDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuXuQiuDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuXuQiu']
            }),
            //项目设计/需求/列表
            bnsXiangMuXuQiuList: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuXuQiuList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMuXuQiu']
            }),
            //项目设计/需求/修改
            bnsXiangMuXuQiuUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuXuQiuUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMuXuQiu']
            }),
            //项目设计/需求/修改保存
            bnsXiangMuXuQiuUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuXuQiuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuXuQiu','yh']
            }),
            //项目设计/产品/新增
            bnsXiangMuBanBenAdd: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuBanBen','yh']
            }),           
            
            //项目设计/产品/删除
            bnsXiangMuBanBenDel: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuBanBen']
            }),
        
            //项目设计/产品/列表
            bnsXiangMuBanBenList: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMuBanBen']
            }),
            //项目设计/产品/修改
            bnsXiangMuBanBenUpdate: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMuBanBen']
            }),
            //项目设计/产品/修改保存
            bnsXiangMuBanBenUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['bnsXiangMuBanBen','yh']
            }),
            //项目设计/评分/新增
            pingfenAdd: build.mutation({
                query(user) {
                    return {
                        url: '/pingfenAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['pingfen','yh']
            }),           
            
            //项目设计/评分/删除
            pingfenDel: build.mutation({
                query(user) {
                    return {
                        url: '/pingfenDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['pingfen']
            }),
        
            //项目设计/评分/列表
            pingfenList: build.query({
                query(user) {
                    return {
                        url: '/pingfenList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['pingfen']
            }),
            //项目设计/评分/修改
            pingfenUpdate: build.query({
                query(user) {
                    return {
                        url: '/pingfenUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['pingfen']
            }),
            //项目设计/评分/修改保存
            pingfenUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/pingfenUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['pingfen','yh']
            }),
            //项目设计/用户/新增
            yhAdd: build.mutation({
                query(user) {
                    return {
                        url: '/yhAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['yh']
            }),           
            
            //项目设计/用户/删除
            yhDel: build.mutation({
                query(user) {
                    return {
                        url: '/yhDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['yh']
            }),
        
            //项目设计/用户/列表
            yhList: build.query({
                query(user) {
                    return {
                        url: '/yhList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['yh']
            }),
            //项目设计/用户/修改
            yhUpdate: build.query({
                query(user) {
                    return {
                        url: '/yhUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['yh']
            }),
            //项目设计/用户/修改保存
            yhUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/yhUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['yh','bnsXiangMu']
            }),
            //后端任务/请求参数/新增
            qingqiucanshuAdd: build.mutation({
                query(user) {
                    return {
                        url: '/qingqiucanshuAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['qingqiucanshu']
            }),           
            
            //后端任务/请求参数/删除
            qingqiucanshuDel: build.mutation({
                query(user) {
                    return {
                        url: '/qingqiucanshuDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['qingqiucanshu']
            }),
        
            //后端任务/请求参数/列表
            qingqiucanshuList: build.query({
                query(user) {
                    return {
                        url: '/qingqiucanshuList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['qingqiucanshu']
            }),
            //后端任务/请求参数/修改
            qingqiucanshuUpdate: build.query({
                query(user) {
                    return {
                        url: '/qingqiucanshuUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['qingqiucanshu']
            }),
            //后端任务/请求参数/修改保存
            qingqiucanshuUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/qingqiucanshuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['qingqiucanshu']
            }),
          
            //微信推广/新增客户名单
            khmdAdd: build.mutation({
                query(user) {
                    return {
                        url: '/khmdAdd',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['khmd']
            }),
            //微信推广/客户名单列表
            khmdList: build.query({
                query(user) {
                    return {
                        url: '/khmdList',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['khmd']
            }),
            //微信推广/删除客户名单
            khmdDel: build.mutation({
                query(user) {
                    return {
                        url: '/khmdDel',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['khmd']
            }),
            //微信推广/修改保存客户名单
            khmdUpdateSave: build.mutation({
                query(user) {
                    return {
                        url: '/khmdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['khmd']
            }),
             //微信推广/客户名单修改
             khmdUpdate: build.query({
                query(user) {
                    return {
                        url: '/khmdUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['khmd']
            }),
            //微信推广/加好友
            khmdjhyUpdate: build.mutation({
                query(user) {
                    return {
                        url: '/khmdjhyUpdate',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['khmd']
            }),
            //微信推广/清除加好友
            khmdjhyQC: build.mutation({
                query(user) {
                    return {
                        url: '/khmdjhyQC',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                invalidatesTags:['khmd']
            }),
            //效果图/效果图/修改日志
            bnsXiangMuBanBenLog: build.query({
                query(user) {
                    return {
                        url: '/bnsXiangMuBanBenLog',
                        method: 'post',
                        body: form_data(user)
                    }
                },
                providesTags:['bnsXiangMuBanBen']
            }),
        }
    }
})

export const {   
    useLoginCodeMutation,
    useUserMmLoginMutation,
    useUserLoginMutation,
    useBnsGoodsAddMutation,
    useBnsGoodsListQuery,
    useBnsGoodsUpdateQuery,
    useBnsGoodsUpdateSaveMutation,
    useBnsGoodsDelMutation,
    useBnsGongNengAddMutation,
    useBnsGongNengDelMutation,
    useBnsGongNengUpdateSaveMutation,
    useBnsGongNengListQuery,
    useBnsGongNengUpdateQuery,
    useBnsXuQiuAddMutation,
    useBnsXuQiuDelMutation,
    useBnsXuQiuStateMutation,
    useBnsXuQiuListQuery,
    useBnsXuQiuUpdateQuery,
    useBnsXuQiuUpdateSaveMutation,
    useTaskManageAddMutation,
    useTaskManageListQuery,
    useTaskManageDelMutation,
    useGetXMTreeQuery,
    useTaskManageUpdateSaveMutation,
    useTaskManageUpdateQuery,
    useTaskManageAuditMutation,
    useHouduankaifaAddMutation,
    useHouduankaifaDelMutation,
    useHouduankaifaListQuery,
    useHouduankaifaUpdateQuery,
    useHouduankaifaUpdateSaveMutation,
    useBnsBanBenAddMutation,
    useBnsBanBenDelMutation,
    useBnsBanBenListQuery,
    useBnsBanBenUpdateQuery,
    useBnsBanBenUpdateSaveMutation,
    useGoodsTypeAddMutation,
    useGoodsTypeDelMutation,
    useGoodsTypeListQuery,
    useGoodsTypeUpdateQuery,
    useGoodsTypeUpdateSaveMutation,
    useGoodsAddMutation,
    useGoodsDelMutation,
    useGoodsListQuery,
    useGoodsUpdateQuery,
    useGoodsUpdateSaveMutation,
    useClientListQuery,
    useClientUpdateQuery,
    useAddClientMutation,
    useDelClientMutation,
    useUpdateSaveClientMutation,
    useGetClientUidQuery,
    useClientTypeAddMutation,
    useClientTypeDelMutation,
    useClientTypeListQuery,
    useClientTypeUpdateQuery,
    useClientTypeUpdateSaveMutation,
    useIncomeExpenditureAddMutation,
    useIncomeExpenditureAuditMutation,
    useIncomeExpenditureCancelAuditMutation,
    useIncomeExpenditureDelMutation,
    useIncomeExpenditureListQuery,
    useIncomeExpenditureUpdateQuery,
    useIncomeExpenditureUpdateSaveMutation,
    useTuanHaoListQuery,
    useShouZhiListQuery,
    useBnsGuiGeAddMutation,
    useBnsGuiGeDelMutation,
    useBnsGuiGeListQuery,
    useBnsGuiGeUpdateQuery,
    useBnsGuiGeUpdateSaveMutation,
    useFinanceSubTypeAddMutation,
    useFinanceSubTypeDelMutation,
    useFinanceSubTypeListQuery,
    useFinanceSubTypeUpdateQuery,
    useFinanceSubTypeUpdateSaveMutation,
    useRenwuAddMutation,
    useRenwuDelMutation,
    useRenwuListQuery,
    useRenwuUpdateQuery,
    useRenwuUpdateSaveMutation,
    useBnsXiangMuAddMutation,
    useBnsXiangMuDelMutation,
    useBnsXiangMuListQuery,
    useBnsXiangMuUpdateQuery,
    useBnsXiangMuUpdateSaveMutation,    
    useGetXMXQTreeQuery,
    useGetXMTree2Query,
    useBnsXiangMuXuQiuAddMutation,
    useBnsXiangMuXuQiuDelMutation,
    useBnsXiangMuXuQiuListQuery,
    useBnsXiangMuXuQiuUpdateQuery,
    useBnsXiangMuXuQiuUpdateSaveMutation,
    useBnsXiangMuBanBenAddMutation,
    useBnsXiangMuBanBenDelMutation,
    useBnsXiangMuBanBenListQuery,
    useBnsXiangMuBanBenUpdateQuery,
    useBnsXiangMuBanBenUpdateSaveMutation,
    usePingfenAddMutation,
    usePingfenDelMutation,
    usePingfenListQuery,
    usePingfenUpdateQuery,
    usePingfenUpdateSaveMutation,
    useYhAddMutation,
    useYhDelMutation,
    useYhListQuery,
    useYhUpdateQuery,
    useYhUpdateSaveMutation,
    useQingqiucanshuAddMutation,
    useQingqiucanshuDelMutation,
    useQingqiucanshuListQuery,
    useQingqiucanshuUpdateQuery,
    useQingqiucanshuUpdateSaveMutation,   
    useKhmdListQuery,
    useKhmdAddMutation,
    useKhmdDelMutation,
    useKhmdUpdateSaveMutation,
    useKhmdUpdateQuery,
    useKhmdjhyUpdateMutation,
    useKhmdjhyQCMutation,
    useBnsXiangMuBanBenLogQuery,
} = BnsKeJiApi;
export default BnsKeJiApi;